export enum WorkingStatusEnum {
  NO_REC = 0,
  WAVE = 1,
  BAR = 2,
  BOTH = 4
}
